import React from 'react';

const LIT = new Set([1, 3, 8, 10, 15, 18]);

const ScheduleVisual = () => (
  <span className="card-visual schedule-visual" aria-hidden="true">
    <span className="mini-calendar">
      <span className="calendar-head"><b>YOUR WEEK</b><span>◷</span></span>
      <span className="week-labels">{['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((d, i) => <i key={i}>{d}</i>)}</span>
      <span className="calendar-grid">{Array.from({ length: 21 }, (_, i) => <i key={i} className={LIT.has(i) ? 'lit' : ''} />)}</span>
    </span>
  </span>
);

const ConnectedVisual = () => (
  <span className="card-visual connected-visual" aria-hidden="true">
    <span className="mini-phone">
      <span className="phone-speaker" />
      <span className="phone-app">GLEAM GURU</span>
      <span className="phone-assignment">
        <span className="assignment-icon">✓</span>
        <b>ASSIGNMENT</b>
        <span className="mock-line" />
        <span className="mock-line short" />
      </span>
      <span className="phone-bottom" />
    </span>
    <span className="notification-orb">1</span>
  </span>
);

const FitVisual = () => (
  <span className="card-visual fit-visual" aria-hidden="true">
    <span className="work-tile home-tile">
      <svg viewBox="0 0 48 48"><path d="M8 23 24 9l16 14M13 21v19h22V21M21 40V28h7v12" /></svg>
      <b>HOUSE</b>
    </span>
    <span className="work-tile commercial-tile">
      <svg viewBox="0 0 48 48"><path d="M12 40V8h24v32M7 40h34M19 15h3m5 0h3m-11 8h3m5 0h3m-11 8h3m5 0h3" /></svg>
      <b>COMMERCIAL</b>
    </span>
  </span>
);

const CARDS = [
  { key: 'schedule', Visual: ScheduleVisual, title: 'Your schedule.', short: 'Tell us when you’re available.',
    detail: 'Tell us what works for your life. Share the days, times, and hours you’re looking for, along with anything you’d like us to understand about your availability. We’ll talk through how your schedule fits the house and commercial cleaning opportunities at Gleam Guru.' },
  { key: 'connected', Visual: ConnectedVisual, title: 'Stay connected.', short: 'Assignments through the Gleam Guru app.',
    detail: 'Receive your cleaning assignments through the dedicated Gleam Guru application. Stay up-to-date with everything and always be on schedule. Having your assignments together gives you a clear place to check what’s coming up, so you can prepare for your day and focus on the work ahead.' },
  { key: 'family', Visual: FitVisual, title: 'Become Family.', short: 'There’s a place for you here.',
    detail: 'Bring your personality, your pride in your work, and your willingness to grow. Whether you’re starting out or bringing years of experience, we’d love to get to know you and see how you can become part of the Gleam Guru family.' },
];

export const WhyGuru = () => (
  <section className="why-guru" id="why-gleam-guru" aria-labelledby="why-title" data-testid="why-guru-section">
    <div className="why-top">
      <p className="section-label">WHY GLEAM GURU</p>
      <h2 id="why-title">Find Your Fit <br /><span>at Gleam Guru.</span></h2>
    </div>
    <div className="why-cards">
      {CARDS.map(({ key, Visual, title, short, detail }) => (
        <details className="why-card" key={key} data-testid={`why-card-${key}`}>
          <summary>
            <Visual />
            <span className="why-card-title">{title}</span>
            <span className="why-short">{short}</span>
            <span className="why-expand" aria-hidden="true">+</span>
          </summary>
          <div className="why-detail"><p>{detail}</p></div>
        </details>
      ))}
    </div>
    <div className="why-requirements">
      <span className="requirement-label">BEFORE YOU APPLY</span>
      <p>All cleaners need reliable transportation and must currently bring their own cleaning supplies and equipment.</p>
    </div>
  </section>
);
